import { render, staticRenderFns } from "./DailyLimitDialog.vue?vue&type=template&id=2e0a47f3"
import script from "./DailyLimitDialog.vue?vue&type=script&lang=js"
export * from "./DailyLimitDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports